import * as React from "react";

const TextSeparator: React.FunctionComponent<{ children: React.ReactNode }> = ({
  children,
}) => <div className="center-separator">{children}</div>;

export default TextSeparator;
